module.exports = __webpack_public_path__ + "img/banner2_7_jp.e7bac98d.png";